export class DealBlockNavigation {
	contentContainers: HTMLElement[] = [];
	constructor(private readonly container: HTMLElement) {}

	init() {
		this.contentContainers = [...this.container.querySelectorAll<HTMLElement>("#dealblock-day, #dealblock-week, #dealblock-month")];

		const navigationChips = [...this.container.querySelectorAll<HTMLElement>("oc-chip-v2")];
		navigationChips.forEach((chip) => {
			chip.addEventListener("click", this.showContentContainer.bind(this));
		});
	}

	showContentContainer(event: PointerEvent) {
		const target = event.target as HTMLElement;
		const value = target.getAttribute("value");

		this.contentContainers.forEach((contentContainer) => {
			if (contentContainer.id === `dealblock-${value}`) {
				contentContainer.style.display = "block";
				return;
			}
			contentContainer.style.display = "none";
		});
	}
}
